import { useQuery } from '@tanstack/react-query';
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';
import { fetchAnalytics } from '../services/api';

export default function Analytics() {
  const { data: analytics, isLoading } = useQuery({
    queryKey: ['analytics'],
    queryFn: fetchAnalytics,
  });

  if (isLoading) {
    return <div className="text-center py-12">Loading...</div>;
  }

  return (
    <div className="px-4 py-6 sm:px-0">
      <h2 className="text-2xl font-semibold text-gray-900 mb-6">Analytics</h2>

      <div className="bg-white shadow rounded-lg p-6 mb-6">
        <h3 className="text-lg font-medium text-gray-900 mb-4">
          Questions Over Time
        </h3>
        <ResponsiveContainer width="100%" height={300}>
          <LineChart data={analytics?.timeline || []}>
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis dataKey="date" />
            <YAxis />
            <Tooltip />
            <Legend />
            <Line type="monotone" dataKey="questions" stroke="#3B82F6" />
            <Line type="monotone" dataKey="conversions" stroke="#10B981" />
          </LineChart>
        </ResponsiveContainer>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
        <div className="bg-white shadow rounded-lg p-6">
          <h3 className="text-lg font-medium text-gray-900 mb-4">
            Top Categories
          </h3>
          <div className="space-y-3">
            {analytics?.topCategories?.map((cat: any, i: number) => (
              <div key={i} className="flex items-center justify-between">
                <span className="text-sm text-gray-900">{cat.name}</span>
                <span className="text-sm font-medium text-blue-600">{cat.count}</span>
              </div>
            )) || <p className="text-gray-500">No data available</p>}
          </div>
        </div>

        <div className="bg-white shadow rounded-lg p-6">
          <h3 className="text-lg font-medium text-gray-900 mb-4">
            Popular Products
          </h3>
          <div className="space-y-3">
            {analytics?.popularProducts?.map((prod: any, i: number) => (
              <div key={i} className="flex items-center justify-between">
                <span className="text-sm text-gray-900">{prod.name}</span>
                <span className="text-sm font-medium text-blue-600">{prod.views}</span>
              </div>
            )) || <p className="text-gray-500">No data available</p>}
          </div>
        </div>
      </div>
    </div>
  );
}
